export async function lazyLoadAuthentication() {
  return import('@cian/authentication-widget');
}
